import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="bg-primary text-white min-h-screen flex items-center relative overflow-hidden">
        <div className="absolute inset-0 bg-primary bg-cover bg-center opacity-30"></div>
        <div className="container mx-auto px-4 py-16 relative z-10 flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <h1 className="text-4xl md:text-6xl font-bold uppercase leading-tight mb-4">
              Reboot Your Brain—Revitalize Your Cells in 7 Days
            </h1>
            <p className="text-xl md:text-2xl mb-8">
              Tri-peptide technology that sharpens focus, stokes metabolism, and jump-starts cellular repair.
            </p>
            <p className="text-lg mb-8">
              30-day supply · $320 (only $10.67 / day)
            </p>
            <a 
              href="https://www.mybodepro.com/jimcarrie/products/1008030" 
              className="bg-[#ff7f00] hover:bg-[#ff9933] text-white font-bold py-4 px-8 rounded-lg text-xl uppercase inline-block transition-all"
            >
              Shop Now!
            </a>
          </div>
          <div className="md:w-1/2 flex justify-center">
            <img 
              src="./images/product-bottle.webp" 
              alt="Neuro Reboot Product Bottle" 
              className="max-w-full h-auto max-h-[500px]"
            />
          </div>
        </div>
      </header>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-2">KEY BENEFITS OF NEURO REBOOT</h2>
          <p className="text-xl text-center mb-12">the ultimate tri-peptide blend for cognitive and metabolic support</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="rounded-lg overflow-hidden shadow-lg">
              <div className="h-64 bg-primary flex items-center justify-center">
                <div className="text-white text-6xl">E</div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-semibold mb-2">Energy & Focus</h3>
                <p className="text-gray-700">Enhance mental clarity and sustained energy throughout the day</p>
              </div>
            </div>
            <div className="rounded-lg overflow-hidden shadow-lg">
              <div className="h-64 bg-primary flex items-center justify-center">
                <div className="text-white text-6xl">L</div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-semibold mb-2">Longevity & Vitality</h3>
                <p className="text-gray-700">Support cellular health for long-term wellness and vitality</p>
              </div>
            </div>
            <div className="rounded-lg overflow-hidden shadow-lg">
              <div className="h-64 bg-primary flex items-center justify-center">
                <div className="text-white text-6xl">C</div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-semibold mb-2">Cellular Renewal</h3>
                <p className="text-gray-700">Promote cellular regeneration and repair at the deepest level</p>
              </div>
            </div>
            <div className="rounded-lg overflow-hidden shadow-lg">
              <div className="h-64 bg-primary flex items-center justify-center">
                <div className="text-white text-6xl">M</div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-semibold mb-2">Metabolic Activation</h3>
                <p className="text-gray-700">Optimize fat metabolism, boost neurotransmitter balance</p>
              </div>
            </div>
            <div className="rounded-lg overflow-hidden shadow-lg">
              <div className="h-64 bg-primary flex items-center justify-center">
                <div className="text-white text-6xl">E</div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-semibold mb-2">Enhance Cognition</h3>
                <p className="text-gray-700">Improve memory, focus, and overall cognitive performance</p>
              </div>
            </div>
            <div className="rounded-lg overflow-hidden shadow-lg">
              <div className="h-64 bg-primary flex items-center justify-center">
                <div className="text-white text-6xl">G</div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-semibold mb-2">Gut-Brain Axis support</h3>
                <p className="text-gray-700">Support the critical connection between gut and brain health</p>
              </div>
            </div>
          </div>
          
          <div className="mt-12 text-center">
            <a 
              href="https://www.mybodepro.com/jimcarrie/products/1008030" 
              className="bg-[#ff7f00] hover:bg-[#ff9933] text-white font-bold py-4 px-8 rounded-lg text-xl uppercase inline-block transition-all"
            >
              Shop Now
            </a>
          </div>
        </div>
      </section>

      <section className="py-16 bg-primary text-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0">
              <h2 className="text-3xl font-bold mb-6">NEURO REBOOT</h2>
              <p className="text-lg mb-4">
                A powerful tri-peptide bioregulator designed to boost brain function, metabolism, and cellular regeneration.
              </p>
              <p className="text-lg mb-4">
                This unique formula blends BPC-157, Tesofensine, and Dihexa, three powerful peptides that work together to support brain health, metabolism, and cellular vitality.
              </p>
              <p className="text-lg mb-4">
                Neuro Reboot provides the targeted support your body and mind need to perform at their best.
              </p>
              <p className="text-lg mb-6">
                Unlike traditional products, Neuro Reboot targets systemic challenges at the cellular level. By utilizing a synergistic combination of peptides, this innovative formula works holistically to support body's core systems simultaneously.
              </p>
            </div>
            <div className="md:w-1/2 flex justify-center">
              <div className="bg-blue-900 bg-opacity-50 rounded-full p-8 flex items-center justify-center">
                <svg className="w-48 h-48 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-4">WHAT MAKES NEURO REBOOT UNIQUE?</h2>
          <p className="text-xl text-center mb-12">Unlock your brain's full potential with advanced peptide technology*</p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="h-48 flex items-center justify-center mb-6">
                <div className="w-32 h-32 rounded-full flex items-center justify-center bg-accent">
                  <svg className="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z"></path></svg>
                </div>
              </div>
              <h3 className="text-2xl font-semibold mb-3">Targeted Support</h3>
              <p className="text-gray-700 px-4">This formula reprograms your brain to help promote neuroplasticity, optimize energy production, and balance neurotransmitters for peak performance.</p>
            </div>
            <div className="text-center">
              <div className="h-48 flex items-center justify-center mb-6">
                <div className="w-32 h-32 rounded-full flex items-center justify-center bg-secondary">
                  <svg className="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"></path></svg>
                </div>
              </div>
              <h3 className="text-2xl font-semibold mb-3">Tri-Peptide Powerhouse</h3>
              <p className="text-gray-700 px-4">Three powerful peptides— BPC-157, Tesofensine, and Dihexa — work to enhance cognitive function, metabolism, and cellular regeneration at the deepest level.</p>
            </div>
            <div className="text-center">
              <div className="h-48 flex items-center justify-center mb-6">
                <div className="w-32 h-32 rounded-full flex items-center justify-center bg-accent">
                  <svg className="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"></path></svg>
                </div>
              </div>
              <h3 className="text-2xl font-semibold mb-3">Long-Term Health</h3>
              <p className="text-gray-700 px-4">By focusing on cellular repair, Neuro Reboot supports long-term brain health, mental clarity, and a resilient metabolism as you age.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-primary text-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-6">Discover the Power of Cellular Communication</h2>
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-3/5 mb-10 md:mb-0">
              <h3 className="text-2xl font-semibold mb-4">WHAT ARE PEPTIDES?</h3>
              <p className="text-lg mb-4">
                Peptides are short chains of amino acids that act as messengers within your body, triggering important biological functions that support health and vitality.
              </p>
              <p className="text-lg mb-4">
                Peptides play a crucial role in cellular communication, helping your body function optimally.
              </p>
              <p className="text-lg mb-4">
                These revolutionary molecules act as messengers within the body, restoring the signaling capacity of your cells and helping them function like they did in their prime.
              </p>
              <p className="text-lg mb-4">
                As we age, our cells begin to lose their vibrational energy, leading to sluggish performance, decreased cognitive function, metabolic imbalances, visible signs of aging, and diminished overall health.
              </p>
              <p className="text-lg">
                Peptides are the future of health and provide powerful, targeted support for optimal living while making your current wellness supplements have an even greater impact on your health.
              </p>
            </div>
            <div className="md:w-2/5 flex justify-center">
              <div className="rounded-full overflow-hidden bg-blue-900 bg-opacity-50 p-8 flex items-center justify-center">
                <svg className="w-48 h-48 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM6.75 9.25a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5zM6.75 7a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5zM6.75 11.5a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z" clipRule="evenodd"></path>
                </svg>
              </div>
            </div>
          </div>
          <div className="mt-12 text-center">
            <a 
              href="https://www.mybodepro.com/jimcarrie/products/1008030" 
              className="bg-[#ff7f00] hover:bg-[#ff9933] text-white font-bold py-4 px-8 rounded-lg text-xl uppercase inline-block transition-all"
            >
              Shop Now
            </a>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-4">ACTIVE INGREDIENTS</h2>
          <p className="text-xl text-center mb-12">three peptides, one powerful synergy for true cellular revitalization</p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-accent bg-opacity-90 text-white rounded-lg p-8 text-center">
              <h3 className="text-2xl font-semibold mb-4">BPC-157</h3>
              <p className="text-lg">Supports tissue repair, reduced markers for inflammation, enhances mitochondrial health, and aids in gut health.</p>
            </div>
            <div className="bg-accent bg-opacity-90 text-white rounded-lg p-8 text-center">
              <h3 className="text-2xl font-semibold mb-4">Tesofensine</h3>
              <p className="text-lg">Optimizes fat metabolism, boosts neurotransmitter balance, and enhances cognitive function and your overall mood.</p>
            </div>
            <div className="bg-accent bg-opacity-90 text-white rounded-lg p-8 text-center">
              <h3 className="text-2xl font-semibold mb-4">Dihexa</h3>
              <p className="text-lg">Promotes neuroplasticity, cognitive resilience, memory retention, and reduces neuroinflammation for long-term brain health.</p>
            </div>
          </div>
          
          <div className="mt-16">
            <div className="border border-gray-300 rounded-lg overflow-hidden">
              <div className="grid grid-cols-2 border-b">
                <div className="p-4 font-semibold border-r">Serving size</div>
                <div className="p-4 font-semibold">2 Tablets</div>
              </div>
              <div className="grid grid-cols-2 border-b">
                <div className="p-4 font-semibold border-r">Servings</div>
                <div className="p-4 font-semibold">30</div>
              </div>
              <div className="grid grid-cols-2">
                <div className="p-4 font-semibold border-r">Retail</div>
                <div className="p-4 font-semibold">$320.00</div>
              </div>
            </div>
            
            <div className="mt-8">
              <h3 className="text-2xl font-semibold mb-4">Inside Every 2-Tablet Serving</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-accent mr-2">✓</span>
                  <span><strong>BPC-157</strong> – Tissue regeneration·Gut repair·Mitochondrial health</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent mr-2">✓</span>
                  <span><strong>Tesofensine</strong> – Accelerated fat metabolism·Elevated focus & mood</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent mr-2">✓</span>
                  <span><strong>Dihexa</strong> – Enhanced memory·Neuroplasticity·Neuro-protection</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>



      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="border border-gray-200 rounded-lg p-6 shadow-md">
              <h3 className="text-xl font-semibold text-center mb-2">Mark D.</h3>
              <div className="flex justify-center mb-3">
                <span className="text-yellow-400 text-2xl">★★★★★</span>
              </div>
              <p className="text-center text-gray-700">"Day 5 and I'm laser-focused through 6pm—no crash."</p>
            </div>
            <div className="border border-gray-200 rounded-lg p-6 shadow-md">
              <h3 className="text-xl font-semibold text-center mb-2">Erin S.</h3>
              <div className="flex justify-center mb-3">
                <span className="text-yellow-400 text-2xl">★★★★★</span>
              </div>
              <p className="text-center text-gray-700">Lost 4lbs the first month without changing my workouts.</p>
            </div>
            <div className="border border-gray-200 rounded-lg p-6 shadow-md">
              <h3 className="text-xl font-semibold text-center mb-2">Mark S.</h3>
              <div className="flex justify-center mb-3">
                <span className="text-yellow-400 text-2xl">★★★★★</span>
              </div>
              <p className="text-center text-gray-700">Joints aren't creaking and I'm running farther than I have in years.</p>
            </div>
          </div>
          
          <div className="mt-8 text-center">
            <p className="text-lg">
              Try Neuro Reboot risk-free. If you don't feel lighter, stronger and more energized, send back the bottle—empty or not—and we'll refund 100% of your purchase.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-primary text-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8">THE SCIENCE BEHIND NEURO REBOOT</h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-lg mb-6">
              The peptides in Neuro Reboot are backed by years of research and clinical evidence demonstrating their efficacy in supporting brain function, metabolic health, and tissue regeneration, thus making Neuro Reboot a scientifically-backed, powerful option for improving both cognitive and physical performance.
            </p>
            <p className="text-lg">
              Clinical studies have shown that these bioavailable peptides enhance cellular energy production and activate longevity pathways, while supporting tissue regeneration and overall health. Additionally, the formula has been shown to enhance mitochondrial biogenesis, reduce oxidative stress, and optimize cellular function.
            </p>
          </div>
          
          <div className="mt-12 bg-blue-900 bg-opacity-30 py-8 px-4 rounded-lg">
            <h3 className="text-2xl font-bold text-center mb-4">
              YOUR ESSENTIAL PEPTIDE-POWERED OPTION FOR COGNITIVE, METABOLIC, AND CELLULAR SUPPORT. ENERGIZE, REFOCUS, AND RESTORE.
            </h3>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8">Everything You've Been Wondering About Neuro Reboot</h2>
          
          <div className="max-w-3xl mx-auto">
            <div className="border border-gray-200 rounded-lg mb-4 overflow-hidden">
              <button
                className="w-full p-4 text-left font-semibold flex justify-between items-center bg-gray-50 hover:bg-gray-100"
              >
                <span>How soon will I notice a change?</span>
                <span className="text-xl">+</span>
              </button>
            </div>
            <div className="border border-gray-200 rounded-lg mb-4 overflow-hidden">
              <button
                className="w-full p-4 text-left font-semibold flex justify-between items-center bg-gray-50 hover:bg-gray-100"
              >
                <span>Do I need a prescription?</span>
                <span className="text-xl">+</span>
              </button>
            </div>
            <div className="border border-gray-200 rounded-lg mb-4 overflow-hidden">
              <button
                className="w-full p-4 text-left font-semibold flex justify-between items-center bg-gray-50 hover:bg-gray-100"
              >
                <span>Is it safe with my current supplements or meds?</span>
                <span className="text-xl">+</span>
              </button>
            </div>
          </div>
          
          <div className="mt-12 text-center">
            <a 
              href="https://www.mybodepro.com/jimcarrie/products/1008030" 
              className="bg-[#ff7f00] hover:bg-[#ff9933] text-white font-bold py-4 px-8 rounded-lg text-xl uppercase inline-block transition-all"
            >
              SHOP NOW!
            </a>
          </div>
        </div>
      </section>

      <footer className="bg-gray-900 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="mb-4">© 2025 BioLimitless. All Rights Reserved.</p>
          <p className="text-sm text-gray-400">
            *These statements have not been evaluated by the Food and Drug Administration. 
            This product is not intended to diagnose, treat, cure, or prevent any disease.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
